import React, {useContext} from "react";
import {createUseStyles, useTheme} from "react-jss";
import Emoji from "react-emoji-render";
import {Theme} from "engage-client/theme";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {EngageAppContext} from "../../App";

const useStyles = createUseStyles<Theme>((theme) => ({
    chatBubbleContainer: {
        padding: [4, 8],
        display: "flex",
        flexDirection: "column",
    },
    chatBubble: {
        backgroundColor: props => props.currentPlayer ? theme.chat.colorDark : theme.chat.colorLight,
        borderRadius: "20px 20px 0px 20px",
        padding: [6, 20],
        maxWidth: "75%",
        alignSelf: props => props.currentPlayer ? "flex-end" : "flex-start",
        textAlign: "left"
    },
    nickname: {
        marginBottom: 4,
        display: "flex",
        flexDirection: "row",
    },
    textEntry: {
        display: "block",
        margin: [2,0],
        lineHeight: 1.1,
        overflowWrap: "break-word",
    },
    onlyEmoji: {
        fontSize: 20,
    },
    newLine: {
        display: "flex",
        flexBasis: "100%",
        alignItems: "center",
        marginBottom: 3,
        opacity: 0.5,
        "&:before, &:after": {
            content: "''",
            flexGrow: 1,
            backgroundColor: "white",
            height: 1,
            fontSize: 0,
            lineHeight: 0,
            margin: [0,8]
        },
    },
    host: {
        marginLeft: 4,
        fontWeight: 400,
    },
}));

type ChatBubbleProps = {
    currentPlayer: boolean
    nickname: string
    team?: string
    text:string[]
    newLine: boolean
    verified?: boolean
}

export const ChatBubble = (props:ChatBubbleProps) => {
    const theme:Theme = useTheme<Theme>();
    const {text, currentPlayer, nickname} = props;
    const classes = useStyles({currentPlayer});

    return (
        <div className={classes.chatBubbleContainer} >
            {props.newLine &&
            <DisplayText variant={TextVariant.s10med} color="white" className={classes.newLine}>New</DisplayText>
            }
            <DisplayText className={classes.chatBubble} variant={TextVariant.s14med}
                         fontWeight={400} color={currentPlayer ? "white" : "#0E1227"}>
                <DisplayText variant={TextVariant.s10med} fontWeight={theme.chat.nicknameFontWeight}
                             color={currentPlayer ? "white": "black"}
                             className={classes.nickname}>
                    {currentPlayer ? "Me" : nickname}
                    {props.team && <div className={classes.teamShadow}><div style={{
                        backgroundColor: theme.teamInfos[props.team].mediumBG,
                        borderRadius: "50%",
                        height: 8,
                        width: 8,
                        marginLeft: 6,
                        display: "inline-block",
                        boxShadow: "0 0 0 2px #0000004D"
                    }}/></div>}
                    {props.verified &&
                    <div className={classes.host}>(Host)</div>
                    }
                </DisplayText>
                {
                    text.map((value,index) =>
                        <Emoji key={index} text={value} className={classes.textEntry} onlyEmojiClassName={classes.onlyEmoji}/>
                    )
                }
            </DisplayText>
        </div>
    );
};